import $ from "jquery";
import * as bootstrap from "bootstrap";
import api from "./ajax";
import renderJobHistory from "./render-job-history";

const emailDockets = () => {
	// On send message modal close - clear the textarea
	const emailDocketsModal = document.getElementById('emailDocketsModal');

	if (!emailDocketsModal) {
		return;
	}

	const sendEmail = document.getElementById('emailDockets');
	const errorAlert = emailDocketsModal.querySelector('.errors');

	// Reset on modal close
	emailDocketsModal.addEventListener('hide.bs.modal',  (event) => {
		const {currentTarget} = event;
		const textarea = $(currentTarget).find('textarea');
		const input = $(currentTarget).find('input');

		textarea.val('');
		input.val('');
		errorAlert.classList.add('d-none');
	});

	sendEmail.addEventListener('click', async (e) => {
		const {currentTarget} = e;

		const jobId = currentTarget.getAttribute('data-job-id');
		const emails = emailDocketsModal.querySelector('input[name="email_to"]').value;
		const message = emailDocketsModal.querySelector('textarea[name="email_message"]').value;
		const modal = bootstrap.Modal.getInstance(emailDocketsModal);
		const modalBody = $(currentTarget).parents('.modal__body');

		modalBody.children('.sending').addClass('show');

		const response = await api.sendJobDockets(emails, message, jobId, this);

		if (response.error) {
			errorAlert.classList.remove('d-none');
		}

		modalBody.children('.sending').removeClass('show');

		if (!response.error) {
			modal.hide();
		}

	});

	// $('#emailDocketsModal #emailDockets').on('click', async (e) => {
	//     const { currentTarget } = e;
	//     const sendButton = $(currentTarget);
	//     const modalBody = sendButton.parents('.modal__body');
	//     const jobId = $('#subContractorsTable').data('job-id') ? $('#subContractorsTable').data('job-id') : false;
	//
	//
	//     const message = $('#emailDocketsModal input[name=email_message]').val();
	//     let modal = document.getElementById('sendMessageModal');
	//
	//     modal = bootstrap.Modal.getInstance(modal);
	//     modalBody.children('.sending').addClass('show');
	//
	//     // const response = await api.sendMessage(sendTo, message, jobId, this);
	//     //
	//     // if (response.error) {
	//     //     return;
	//     // }
	//     //
	//     // // Update the Job History
	//     // if (jobId) {
	//     //     const jobHistory = await api.getJobHistory(jobId, this);
	//     //
	//     //     if (jobHistory.error) {
	//     //         return;
	//     //     }
	//     //
	//     //     const jobHistoryHtml = renderJobHistory(jobHistory.body);
	//     //
	//     //     // Build HTML for job history items and then replace html in history list
	//     //     jobHistoryList.html(jobHistoryHtml);
	//     // }
	//     //
	//     // modal.hide();
	//     // modalBody.children('.sending').removeClass('show');
	// });
}

export default emailDockets;